<template>
  <v-dialog v-model="value" max-width="600px" persistent>
    <v-card>
      <v-card-title><span class="headline font-weight-thin">Edit Go Live Date</span> </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="form" v-if="serviceAreaRecordClone">
          <br />
          <date-picker
            :isRequired="true"
            :value="goLiveDate"
            @selectedDate="select('goLiveDate', $event)"
            attributeName="goLiveDate"
            clearIcon="fa fa-times"
            hint="If typing in the date, use the format YYYY-MM-DD."
            label="Go Live Date"
          >
          </date-picker>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="close" data-cy="cancelButton" outlined small>Cancel</v-btn>
            <v-tooltip v-model="show" top v-if="!inputsHaveChanged()">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    @click="save"
                    :disabled="!valid || !inputsHaveChanged()"
                    class="ml-2"
                    color="primary"
                    data-cy="saveButton"
                    outlined
                    small
                    >Save</v-btn
                  >
                </div>
              </template>
              <span>Form cannot be saved unless values have changed.</span>
            </v-tooltip>
            <v-btn
              @click="save"
              :disabled="!valid || !inputsHaveChanged()"
              class="ml-2"
              color="primary"
              data-cy="saveButton"
              outlined
              small
              v-else
              >Save</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { cloneDeep } from "lodash";
import { mapActions } from "vuex";
import { formatForApiToUTC, formatDateAsHyphenatedYYYYMMDD } from "@/lib/formatters";

import DatePicker from "@/components/datePicker.vue";

export default {
  components: { DatePicker },
  data() {
    return {
      goLiveDate: null,
      serviceAreaRecordClone: null,
      show: false,
      valid: true,
    };
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    inputsHaveChanged() {
      if (!this.serviceAreaRecordClone.goLiveDate && !this.goLiveDate) {
        return false;
      }
      const isDifferent = formatDateAsHyphenatedYYYYMMDD(this.serviceAreaRecord.goLiveDate) !== this.goLiveDate;

      return isDifferent;
    },
    async save() {
      const { id: serviceAreaId } = this.serviceAreaRecord;
      /* 
      The date picker sets the date to the 0 hour of the day, 
      but the API expects a UTC date in the format YYYY-MM-DD with an offset for local time.
      (In some places in the application we are handling it on the back-end.)
      */
      const formattedDate = formatForApiToUTC(this.goLiveDate);
      const serviceAreaData = {
        serviceAreaId,
        data: {
          goLiveDate: formattedDate,
        },
      };

      try {
        await this.patchUpdate(serviceAreaData);
        this.$notifySuccess("Successfully updated");
      } catch (e) {
        console.error(e);
        return this.$notifyError("Error updating Go Live Date");
      }
      this.close();
    },
    select(attribute, val) {
      this.goLiveDate = val;
    },
    ...mapActions({
      loadUserList: "user/load",
      patchUpdate: "admin/serviceArea/patchUpdate",
    }),
  },
  props: {
    serviceAreaRecord: { default: null, required: true, type: Object },
    value: { required: true, type: Boolean },
  },
  watch: {
    value(val) {
      if (val) {
        this.serviceAreaRecordClone = cloneDeep(this.serviceAreaRecord);
        // The date-picker expects a date in the format YYYY-MM-DD
        if (!this.serviceAreaRecordClone.goLiveDate) {
          this.goLiveDate = null;
          return;
        }
        this.goLiveDate = formatDateAsHyphenatedYYYYMMDD(this.serviceAreaRecordClone.goLiveDate);
      }
    },
  },
};
</script>
